<div id="layout-wrapper">
  <app-sidebar class="sticky-lg-top" [isCondensed]="isCondensed"></app-sidebar>

  <div class="h-100">
    <div class="px-md-4">
      <!-- Trial Banner -->
      <div
        *ngIf="isTrialAcademy"
        class="bg-warning text-center main-content p-2 text-white"
      >
        {{
          'SHARED.TRIAL_BANNER_MESSAGE'
            | translate: { days: trialDaysRemaining }
        }}
      </div>
      <!-- showSubscriptionNearExpiryBanner -->
      <div
        *ngIf="showSubscriptionNearExpiryBanner && isBranchMode"
        class="bg-warning text-center main-content p-2 text-white"
      >
        {{
          'EXPENSES_CATEGORIES.MESSAGES.NEAR_EXPIRY_BODY'
            | translate: { days: academySubscriptionDaysRemaining }
        }}
      </div>
    </div>
    <div class="p-md-4 h-100">
      <div class="main-content card shadow-none p-3 p-md-4 h-100">
        <ng-content select="[hehehe]"></ng-content>

        <!-- class="sticky-lg-top" -->
        <app-topbar
          (settingsButtonClicked)="onSettingsButtonClicked()"
          (mobileMenuButtonClicked)="onToggleMobileMenu()"
        >
        </app-topbar>
        <div class="mw-1920px w-100 mx-auto mt-3">
          <!-- content -->
          <router-outlet> </router-outlet>
        </div>
        <mg-left-sidebar class=""></mg-left-sidebar>

        <!-- footer -->
        <!-- <app-footer></app-footer> -->
      </div>
    </div>
  </div>
</div>

<!-- Support desk launcher; stays mounted across route changes (FEAT-057 REQ-001). -->
<app-support-launcher></app-support-launcher>

<img
  *ngIf="EIDDESIGN"
  src="../../../assets/images/sheap_butcher.gif"
  class="bottom-0 position-fixed start-0 sheap_moved _2"
  alt=""
/>
